import axios from "axios";
import { logout } from "./auth.action";
import { endpointApi } from "../../utils";
import { BAMBOU_LIST_FAIL, BAMBOU_LIST_REQUEST, BAMBOU_LIST_SUCCESS, BAMBOU_LIST_UPDATE } from "../constats/bambou.constant";

export const getBambous = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: BAMBOU_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }bambous${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: BAMBOU_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: BAMBOU_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: BAMBOU_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}

export const updateElementInList = (element) => async(dispatch) => {
    dispatch({
        type: BAMBOU_LIST_UPDATE,
        payload: element
    })
}